import axios from "axios";
import { Dispatch } from "redux";
import {
  LOADING_UI,
  START_LOADING_USER,
  STOP_LOADING_UI,
  STOP_LOADING_USER,
} from "../../types/ui/UiReducerTypes";
import {
  CONTACT_SUBSCRIBE,
  FORGOT_RESET_PASSWORD,
  REMOVE_USER,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  SET_USER,
} from "../../types/user/UserActionTypes";
const api = axios.create({
  baseURL: "https://good-regime.herokuapp.com",
  // baseURL: "http://localhost:90",

  headers: { Authorization: localStorage.userToken },
});
export const userLogin =
  (userData: IuserData) => async (dispatch: Dispatch) => {
    try {
      const res = await api.post("/user/login", userData);
      if (res.data.success) {
        dispatch({ type: SET_AUTHENTICATED, payload: res.data });
        setTokenToLocalStorage(res.data.token);
        getUserData();
        window.location.href = "/";
      } else dispatch({ type: SET_UNAUTHENTICATED, payload: res.data });
    } catch {
      dispatch({ type: SET_UNAUTHENTICATED });
    }
  };
//------------------------Google login
export const userGoogleLogin =
  (tokenId: string) => async (dispatch: Dispatch) => {
    try {
      const res = await api.post("/client/googleLogin", { tokenId });
      if (res.data.success) {
        dispatch({ type: SET_AUTHENTICATED, payload: res.data });
        setTokenToLocalStorage(res.data.token);
        getUserData();
        window.location.href = "/";
      } else dispatch({ type: SET_UNAUTHENTICATED, payload: res.data });
    } catch {
      dispatch({ type: SET_UNAUTHENTICATED });
    }
  };
export const userRegistration =
  (userData: IuserReg, history: any) => async (dispatch: Dispatch) => {
    try {
      const res = await api.post("/user/registration", userData);
      if (res.data.success) {
        dispatch({ type: SET_UNAUTHENTICATED, payload: res.data });
        history.push("/user-register-completion");
      } else dispatch({ type: SET_UNAUTHENTICATED, payload: res.data });
    } catch {
      dispatch({ type: SET_UNAUTHENTICATED });
    }
  };
export const getUserData =
  () =>
  // const dispatch = useDispatch();
  async (dispatch: Dispatch) => {
    // console.log("pukar");
    dispatch({ type: START_LOADING_USER });
    try {
      const res = await api.get("/user/getMe");
      dispatch({ type: SET_USER, payload: res.data });
      dispatch({ type: STOP_LOADING_USER });
    } catch (err) {
      console.log(err);
    }
  };
export const contactUs =
  (data: IContact, history: any) => async (dispatch: Dispatch) => {
    try {
      const res = await api.post("/contact/addNew", data);
      if (res.data.success) {
        dispatch({ type: CONTACT_SUBSCRIBE, payload: res.data });
        history.push("/");
      }
    } catch (err) {
      console.log(err);
    }
  };
export const subscribe = (email: string) => async (dispatch: Dispatch) => {
  try {
    const res = await api.post("/subscribe/addNew", { email });
    if (res.data.success) {
      dispatch({ type: CONTACT_SUBSCRIBE, payload: res.data });
    }
  } catch (err) {
    console.log(err);
  }
};
export const emailVerification = (props: any) => async () => {
  try {
    const res = await api.get(
      "user/registration-confirmation/" + props.match.params.confirmationKey
    );
  } catch (err) {
    console.log(err);
  }
};

export const forgotPassword =
  (forgotEmail: string) => async (dispatch: Dispatch) => {
    try {
      const res = await api.put("/user/forgot-password", { forgotEmail });
      dispatch({ type: FORGOT_RESET_PASSWORD, payload: res.data });
    } catch (err) {
      console.log(err);
    }
  };
export const resetPassword =
  (props: any, NewPassword: string, VerifyNewPassword: string) =>
  async (dispatch: Dispatch) => {
    try {
      const res = await api.put(
        "/user/reset-password/" + props.match.params.resetKey,
        { NewPassword, VerifyNewPassword }
      );

      dispatch({ type: FORGOT_RESET_PASSWORD, payload: res.data });
      if (res.data.success === true) {
        window.location.href = "/user-login";
      }
    } catch (err) {
      console.log(err);
    }
  };
export const uploadProfileImg =
  (profilePicture: any) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });

    try {
      const res = await api.put("/user/updateProfilePicture", profilePicture);
      dispatch({ type: SET_USER, payload: res.data });
      dispatch({ type: STOP_LOADING_UI });
    } catch (err) {
      console.log(err);
    }
  };
//For updating user info
export const updateProfileInfo =
  (userData: IuserReg) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    try {
      const res = await api.put("/user/updateProfileDetails", userData);
      dispatch({ type: SET_USER, payload: res.data });
      dispatch({ type: STOP_LOADING_UI });
    } catch (err) {
      console.log(err);
    }
  };

//For changing user password
export const changePassword =
  (password: IChangePassword, history: any) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    try {
      const res = await api.put("/user/updatePassword", password);
      if (res.data.success) {
        dispatch({ type: REMOVE_USER, payload: res.data });
        localStorage.removeItem("userToken");
        delete axios.defaults.headers.common["Authorization"];
        dispatch({ type: SET_UNAUTHENTICATED });
        history.push("/user-login");
      } else if (!res.data.success) {
        dispatch({ type: SET_USER, payload: res.data });
      }

      dispatch({ type: STOP_LOADING_UI });
    } catch (err) {
      console.log(err);
    }
  };
export const deactivateAccount =
  (history: any) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    try {
      const res = await api.put("/user/deactivateAccount");
      if (res.data.success) {
        dispatch({ type: REMOVE_USER, payload: res.data });
        localStorage.removeItem("userToken");
        delete axios.defaults.headers.common["Authorization"];
        dispatch({ type: SET_UNAUTHENTICATED });
        history.push("/");
      }
      dispatch({ type: STOP_LOADING_UI });
    } catch (err) {
      console.log(err);
    }
  };
export const logoutUser = (history: any) => async (dispatch: Dispatch) => {
  dispatch({ type: REMOVE_USER });
  localStorage.removeItem("userToken");
  delete axios.defaults.headers.common["Authorization"];
  dispatch({ type: SET_UNAUTHENTICATED });
  history.push("/");
};

const setTokenToLocalStorage = (token: String) => {
  const userToken = `Bearer ${token}`;
  localStorage.setItem("userToken", userToken);
  axios.defaults.headers.common["Authorization"] = userToken;
};
